import { call, put, takeEvery } from "redux-saga/effects";

import { ResponseGenerator } from "../../interfaces";
import {
  ADD_PLAN,
  AddPlanAction,
  DELETE_PLAN,
  DeletePlanAction,
  GET_PLAN,
  GET_PLANS,
  GET_PURCHASEABLE_PLANS_FOR_STUDENT,
  GetPlanAction,
  GetPlansAction,
  GetPurchaseablePlansForStudentAction,
  TOGGLE_PLAN_STATE,
  TogglePlanStateAction,
  UPDATE_PLAN,
  UpdatePlanAction,
  UPLOAD_PLAN_IMAGE,
  UploadPlanImageAction,
} from "./actionTypes";
import {
  addPlanError,
  addPlanSuccess,
  deletePlanError,
  deletePlanSuccess,
  getPlanError,
  getPlansError,
  getPlansSuccess,
  getPlanSuccess,
  getPurchaseablePlansForStudentError,
  getPurchaseablePlansForStudentSuccess,
  togglePlanStateError,
  togglePlanStateSuccess,
  updatePlanError,
  updatePlanSuccess,
  uploadPlanImageError,
  uploadPlanImageProgress,
  uploadPlanImageSuccess,
} from "./actions";
import {
  addPlan,
  deletePlan,
  getPlan,
  getPlans,
  getPurchaseablePlansForStudent,
  togglePlanState,
  updatePlan,
  uploadPlanImage,
} from "../../helpers/backend_helper";
import { store } from "..";

function* addPlanSaga({ payload: { request } }: AddPlanAction) {
  try {
    const response: ResponseGenerator = yield call(addPlan, request);
    yield put(addPlanSuccess(response.data));
  } catch (error) {
    yield put(addPlanError(error));
  }
}

function* getPlansSaga({ payload: { courseId, gradeId } }: GetPlansAction) {
  try {
    const response: ResponseGenerator = yield call(getPlans, courseId, gradeId);
    yield put(getPlansSuccess(response.data));
  } catch (error) {
    yield put(getPlansError(error));
  }
}

function* getPlanSaga({ payload: { id } }: GetPlanAction) {
  try {
    const response: ResponseGenerator = yield call(getPlan, id);
    yield put(getPlanSuccess(response.data));
  } catch (error) {
    yield put(getPlanError(error));
  }
}

function* updatePlanSaga({ payload: { id, request } }: UpdatePlanAction) {
  try {
    const response: ResponseGenerator = yield call(updatePlan, id, request);
    yield put(updatePlanSuccess(response.data));
  } catch (error) {
    yield put(updatePlanError(error));
  }
}

function* uploadPlanImageSaga({
  payload: { file, localId, planId },
}: UploadPlanImageAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadPlanImage,
      file,
      localId,
      (progress: number, localId: number) => {
        store.dispatch(uploadPlanImageProgress(localId, Math.round(progress)));
      },
      planId
    );
    yield put(uploadPlanImageSuccess(localId, response.data));
  } catch (error) {
    yield put(uploadPlanImageError(localId, error));
  }
}

function* deletePlanSaga({ payload: { id, history } }: DeletePlanAction) {
  try {
    yield call(deletePlan, id);
    yield put(deletePlanSuccess());
  } catch (error) {
    yield put(deletePlanError(error));
  }
}

function* togglePlanStateSaga({
  payload: { id, history },
}: TogglePlanStateAction) {
  try {
    yield call(togglePlanState, id);
    yield put(togglePlanStateSuccess(id));
  } catch (error) {
    yield put(togglePlanStateError(error));
  }
}

function* getPurchaseablePlansStudentSaga({
  payload: { courseId, gradeId, userId },
}: GetPurchaseablePlansForStudentAction) {
  try {
    const response: ResponseGenerator = yield call(
      getPurchaseablePlansForStudent,
      courseId,
      gradeId,
      userId
    );
    yield put(getPurchaseablePlansForStudentSuccess(response.data));
  } catch (error) {
    yield put(getPurchaseablePlansForStudentError(error));
  }
}

function* PlanSaga() {
  yield takeEvery(GET_PLAN, getPlanSaga);
  yield takeEvery(UPDATE_PLAN, updatePlanSaga);
  yield takeEvery(GET_PLANS, getPlansSaga);
  yield takeEvery(UPLOAD_PLAN_IMAGE, uploadPlanImageSaga);
  yield takeEvery(ADD_PLAN, addPlanSaga);
  yield takeEvery(DELETE_PLAN, deletePlanSaga);
  yield takeEvery(TOGGLE_PLAN_STATE, togglePlanStateSaga);
  yield takeEvery(
    GET_PURCHASEABLE_PLANS_FOR_STUDENT,
    getPurchaseablePlansStudentSaga
  );
}

export default PlanSaga;
